import React from 'react'
import { useSelector } from 'react-redux'
import ExpenseCategoryDropdown from 'src/components/ExpenseCategoryDropdown/ExpenseCategoryDropdown'
import { useExtendLocation } from 'src/hooks/locationHooks'
import { translateSingleString } from 'src/localization/Trns'
import {
  activeAlphabeticalExpenseCategoryFiltersRequestParams,
  useQueryExpenseCategories,
} from 'src/queries/organizations/expenseCategories.queries'
import { defaultQueryCacheOptions } from 'src/queries/queries.constants'
import { selectNullSafeLocaleFromState } from 'src/redux/selectors/auth.selectors'
import { css } from 'styled-components'

interface ExpenseCategoriesFiltersProps {
  expenseDetails: Record<string, Set<string>>
  onExpenseCategoryChange: (categoryId: string, labelId: string) => void
  onResetClick: (expCatId: string) => void
}

/* Mimicks the ExpenseCategoriesInput component but is specialized for filtering */
const ExpenseCategoriesFilters: React.FC<ExpenseCategoriesFiltersProps> = (
  props,
): React.ReactElement => {
  const locale = useSelector(selectNullSafeLocaleFromState)
  const extendLocation = useExtendLocation()

  const { data: expCatSchema } = useQueryExpenseCategories({
    filters: activeAlphabeticalExpenseCategoryFiltersRequestParams,
    queryCacheOptions: defaultQueryCacheOptions,
    additionalKey: extendLocation.matchedPath,
  })

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      {expCatSchema?.map((expCat, i) => {
        return (
          <div
            key={i}
            css={css`
              :not(:first-child) {
                margin-top: ${'20px'};
              }
            `}
          >
            <ExpenseCategoryDropdown
              expCatId={expCat.id}
              isMulti
              fieldLabel={expCat.name}
              hideToolipOnUpdate
              validateNewOption={
                expCat.freeTextAllowed ? (): boolean => true : undefined
              }
              selectedValues={props.expenseDetails?.[expCat.id]}
              chooseOption={(val: string): void => {
                props.onExpenseCategoryChange(expCat.id, val)
              }}
              onResetClick={(): void => props.onResetClick(expCat.id)}
              placeholder={translateSingleString(locale, 'All labels')}
              textInputPlaceholder={translateSingleString(locale, 'All labels')}
              freeTextAllowed={false}
              hasLabels={expCat.hasLabels}
              css={css`
                &:nth-child(n + 2) {
                  margin-top: 24px;
                }
              `}
            />
          </div>
        )
      })}
    </div>
  )
}

export default ExpenseCategoriesFilters
